/**
 * Message type validators and utilities for SignalR messages
 * Since we're using JavaScript (not TypeScript), we validate message structure at runtime
 */

// Session ID key for localStorage
export const SESSION_ID_KEY = 'SESSION_ID';

// Valid client types
export const CLIENT_TYPES = {
  BROWSER: 'browser',
  EXTENSION: 'extension',
};

// Message operation types
export const MESSAGE_OPERATIONS = {
  FORCE_LOGOUT: 'FORCELOGOUT',
  EXPORT_COMPLETE: 'EXPORTCOMPLETE',
  ENRICHMENT_COMPLETE: 'ENRICHMENTCOMPLETE',
};

/**
 * Validates if message is a ForceLogout message
 * Expected structure: { operation: 'FORCELOGOUT', sessionId?: string, type: string }
 */
export function isForceLogoutMessage(msg) {
  return (
    msg &&
    typeof msg === 'object' &&
    msg.operation === MESSAGE_OPERATIONS.FORCE_LOGOUT &&
    typeof msg.type === 'string'
  );
}

/**
 * Validates if message is an ExportComplete message
 * Expected structure: { operation: 'EXPORTCOMPLETE', exportHistoryId: number, success: boolean }
 */
export function isExportCompleteMessage(msg) {
  return (
    msg &&
    typeof msg === 'object' &&
    msg.operation === MESSAGE_OPERATIONS.EXPORT_COMPLETE &&
    typeof msg.exportHistoryId === 'number'
  );
}

/**
 * Validates if message is an EnrichmentComplete message
 * Expected structure: { operation: 'ENRICHMENTCOMPLETE', enrichmentId: number }
 */
export function isEnrichmentCompleteMessage(msg) {
  return (
    msg &&
    typeof msg === 'object' &&
    msg.operation === MESSAGE_OPERATIONS.ENRICHMENT_COMPLETE &&
    typeof msg.enrichmentId === 'number'
  );
}

/**
 * Validates client type string
 */
export function isValidClientType(type) {
  return Object.values(CLIENT_TYPES).includes(type);
}
